import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import EditContext from './components/EditContext';
import EditLogo from './components/EditLogo';
import Header from './components/Header';
import AiboatVideoSection from './components/AiboatVideoSection'
import TopActionButton from './components/TopActionButton';
import axios from './config/axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContext, postContext } from './features/appSlice';
import { useParams } from 'react-router-dom';
import PersonalizedDemo from './components/playgroungdemo/PersonalizedDemo';
import PreviewChat from './components/chatbotpreview/PreviewChat';
import Modal from './ui/modal/Modal';
import { demoFormAction, postDemoForm } from './features/demoFormSlice';
import config from '../src/config/config'
import ModalSignup from './ui/modal/modalSignup';

function App() {
	const domainlist = ['dev.zyratalk.com', 'uat.zyratalk.com', 'www.zyratalk.com', 'zyratalk.com', 'localhost']; 
	const contextId = useParams();
	const [contextData, setcontextData] = useState({});
	const [defaultContext, setdefaultContext] = useState(null);
	const [defaultLoader, setdefaultLoader] = useState(true);
	const [showAskForModal, setshowAskForModal] = useState(false);
	const [modalBody, setmodalBody] = useState('');
	const [modalFooter, setmodalFooter] = useState('');
	const [modaltitle, setModalTitle] = useState('');
	const [modalLoader, setmodalLoader] = useState(false);
	const companyNameRef = useRef();
	const companyContactNumberRef = useRef();
	const companyUrlRef = useRef();
	const emailLeadRef = useRef();
	const phoneNumberToSendLeadRef = useRef();
	const websiteManagerNameRef = useRef();
	const websiteManagerEmailRef = useRef();
	const additionalNotesRef = useRef();
	const [formLoading, setformLoading] = useState(false);
	const [clientIpAddress, setclientIpAddress] = useState('');
	const toastid = useRef(null);

	const dispatch = useDispatch();
	const [domain, setDomain] = useState('');
	useEffect(() => {
		getIPAddress();
		const domaina = !domainlist.includes(window.location.hostname) ? window.location.hostname : '';
		setDomain(domaina);
		dispatch(fetchContext({ id: contextId.id, domain: domaina }));
	}, []);

	const getIPAddress = () => {
		axios.get('https://api64.ipify.org/?format=json').then((res) => {
			console.log(res);
			setclientIpAddress(res.data?.ip)
		}).catch((err) => {
			console.log(err);
		});
	}

	const state = useSelector((state) => state);

	useEffect(() => {
		setmodalBody(setupAccountForm());
	}, [state.demoForm]);

	// console.log(state.demoForm);
	const onAddQuestionFaq = () => {

	}

	const openDemoForm = () => {
		// if(state.app.playgroundUniqueId){
		setshowAskForModal(true);
		setmodalBody(setupAccountForm());
		// }else{
		// 	toast.error('Please save context data to continue.', {
		// 		position: "top-right",
		// 		autoClose: 5000,
		// 		hideProgressBar: false,
		// 		closeOnClick: true,
		// 		pauseOnHover: true,
		// 		draggable: true,
		// 		progress: undefined,
		// 		theme: "light",
		// 	});
		// }

	}

	const closeModal = () => {
		setshowAskForModal(false);
	}

	const captureEmailFocus = (e) => {
		console.log(e);
	}

	const removeSendEmailLead = (e) => {
		dispatch(demoFormAction.deleteEmailLead(e));
	}

	const checkReadAndAgree = () => {
		dispatch(demoFormAction.checkAgree());
	}
	const handleFormInput = (e, inputRef) => {
		const payl = [inputRef.current.name, inputRef.current.value];
		dispatch(demoFormAction.onAddFormInput(payl));
		// console.log(formRef.current);
	}
	const keylist = [13, 188];
	const emailLeadKeyCheck = (e, emailRef) => {
		console.log(e.keyCode);
		if (keylist.includes(e.keyCode)) {
			if (state.demoForm.emailToSendLeads.includes(emailRef.current.value)) {
				return;
			}
			if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailRef.current.value)) {

				toast.error('Email id is invalid.', {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					// progress: undefined,
					theme: "light",
				});
				return;
			}
			// console.log(emailRef.current.value);
			dispatch(demoFormAction.addEmailLeadList(emailRef.current.value));
		}
	}
	const emailFocusOut = (e, emailRef) => {
		if (!emailRef.current.value) {
			return;
		}
		if (state.demoForm.emailToSendLeads.includes(emailRef.current.value)) {
			return;
		}
		if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailRef.current.value)) {

			toast.error('Email id is invalid.', {
				position: "top-right",
				autoClose: 2000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				// progress: undefined,
				theme: "light",
			});
			return;
		}
		dispatch(demoFormAction.addEmailLeadList(emailRef.current.value));
	}

	const submitDemoForm = async () => {
		if (!state.demoForm.companyName) {
			toast.error('Company name is required.', {
				position: "top-right",
				autoClose: 6000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
			});
			return;
		}

		if (!state.demoForm.readAndAgree) {
			toast.error('Please check Terms and Privacy Policy checkbox.', {
				position: "top-right",
				autoClose: 6000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
			});
			return;
		}

		const data = JSON.parse(JSON.stringify(state.demoForm));
		data['emailToSendLeads'] = JSON.stringify(data['emailToSendLeads']);
		data.ipAddress = clientIpAddress;
		data.playground = state.app.playgroundUniqueId;
		delete data['submitDisable'];
		let statedata = JSON.parse(JSON.stringify(state.app.contextData));
		let myform = document.getElementById("editlogoform");
		let formData = new FormData(myform);
		formData.append('about_us', JSON.stringify(statedata.about_us));
		formData.append('additonal_faq_context', statedata.additonal_faq_context);
		formData.append('business_categories', JSON.stringify(statedata.business_categories));
		formData.append('buttonColor', statedata.buttonColor);
		formData.append('buttonHeaderColor', statedata.buttonHeaderColor);
		formData.append('buttonTextColor', statedata.buttonTextColor);
		formData.append('company_information', JSON.stringify(statedata.company_information));
		formData.append('conversation_goal', statedata.conversation_goal);
		formData.append('primaryColor', statedata.primaryColor);
		formData.append('secondaryColor', statedata.secondaryColor);
		formData.append('selectedTheme', statedata.selectedTheme);
		formData.append('your_faq', JSON.stringify(statedata.your_faq));
		formData.append('zipcoderules', JSON.stringify(statedata.zipcoderules));
		formData.append('company_overview', statedata.company_overview);
		if (state.app.playgroundUniqueId) {
			formData.append('playgroundId', state.app.playgroundId);
			formData.append('playgroundUniqueId', state.app.playgroundUniqueId);
		}
		axios.post('/playgroundController/savePlayground', formData).then((res) => {
			if (res.status) {
				const resdata = res.data;
				if (resdata.status && resdata.playground) {
					data.playground = resdata.playground;
					dispatch(postDemoForm(data));
				} else {
					toast.error('Something went wrong.', {
						position: "top-right",
						autoClose: 400,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",
					});
				}
			} else {
				toast.error('Something went wrong.', {
					position: "top-right",
					autoClose: 400,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light",
				});
			}
		}).catch((err) => {
			console.log(err);
			toast.error('Something went wrong.', {
				position: "top-right",
				autoClose: 400,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
			});
		})
	}
	const LoadingTost = () => {
		return (
			<div className="d-flex align-items-center text-success">
				<strong>Loading...</strong>
				<div className="spinner-border ml-auto" role="status" aria-hidden="true"></div>
			</div>
		)
	}
	const setupAccountForm = () => {
		return (
			<div className='row px-2 py-4'>
				<div className='col-md-12 setupaccount-title'>
					<h3 className='box-title'>Setup my account</h3>
					<p>We will use the customization provided above to create your account</p>
				</div>
				<div className='col-md-12 px-5 setupaccount-body'>
					<div className='form-group'>
						<input
							type="text"
							name='companyName'
							className='form-control'
							placeholder='Company Name'
							ref={companyNameRef}
							value={state.demoForm.companyName}
							onChange={(e) => handleFormInput(e, companyNameRef)}
						/>
					</div>
					<div className='form-group'>
						<input
							type="text"
							name='companyContactNumber'
							className='form-control'
							placeholder='Company Contact Number'
							value={state.demoForm.companyContactNumber}
							ref={companyContactNumberRef}
							onChange={(e) => handleFormInput(e, companyContactNumberRef)}
						/>
					</div>
					<div className='form-group'>
						<input
							type="text"
							name='companyUrl'
							className='form-control'
							placeholder='Company URL'
							value={state.demoForm.companyUrl}
							ref={companyUrlRef}
							onChange={(e) => handleFormInput(e, companyUrlRef)}
						/>
					</div>
					<div className='form-group'>
						<div className='bootstrap-tagsinput'>
							{state.demoForm.emailToSendLeads && state.demoForm.emailToSendLeads.map((item, i) => (
								<span className="tag label label-info">{item}<span data-role="remove" onClick={() => removeSendEmailLead(i)}>
								</span></span>
							))}
							<input
								type="text"
								name='emailLead'
								className='form-control'
								placeholder='Emails to send leads to'
								value={state.demoForm.emailLead}
								ref={emailLeadRef}
								onChange={(e) => handleFormInput(e, emailLeadRef)}
								onKeyDown={(e) => emailLeadKeyCheck(e, emailLeadRef)}
								onBlur={(e) => emailFocusOut(e, emailLeadRef)}
							/>
						</div>
						<small>Use commas (,) or Press Enter key as separators for multiple email recipients</small>
					</div>
					<div className='form-group'>
						<input
							type="text"
							name='phoneNumberToSendLead'
							className='form-control'
							placeholder='Phone numbers to send leads to (optional)'
							value={state.demoForm.phoneNumberToSendLead}
							ref={phoneNumberToSendLeadRef}
							onChange={(e) => handleFormInput(e, phoneNumberToSendLeadRef)}
						/>
					</div>
					<div className='form-group'>
						<input
							type="text"
							name='websiteManagerName'
							className='form-control'
							placeholder='Website Manager Name'
							value={state.demoForm.websiteManagerName}
							ref={websiteManagerNameRef}
							onChange={(e) => handleFormInput(e, websiteManagerNameRef)}
						/>
					</div>
					<div className='form-group'>
						<input
							type="text"
							name='websiteManagerEmail'
							className='form-control'
							placeholder='Website Manager Email'
							value={state.demoForm.websiteManagerEmail}
							ref={websiteManagerEmailRef}
							onChange={(e) => handleFormInput(e, websiteManagerEmailRef)}
						/>
					</div>
					<div className='form-group'>
						<input
							type="text"
							name='additionalNotes'
							className='form-control'
							placeholder='Additional Notes (optional)'
							value={state.demoForm.additionalNotes}
							ref={additionalNotesRef}
							onChange={(e) => handleFormInput(e, additionalNotesRef)}
						/>
					</div>
					<div className='form-group'>
						<div class="mb-3 form-check">
							<input
								name='readAndAgree'
								type="checkbox"
								class="form-check-input"
								id="checkmeout"
								checked={state.demoForm.readAndAgree}
								onChange={checkReadAndAgree}
							/>
							<label class="form-check-label" htmlFor="checkmeout">I have read and agree with ZyraTalk's <a href="https://www.zyratalk.com/terms" target="_blank" style={{ textDecoration: 'none' }}>Terms of Use</a>, <a href="https://www.zyratalk.com/platformagreement" target="_blank" style={{ textDecoration: 'none' }}>Platform Agreement</a> and <a href="https://www.zyratalk.com/privacy" target="_blank" style={{ textDecoration: 'none' }}>Privacy Policy</a></label>
							<p class="text-danger small" id="checkmeoutError"></p>
						</div>
					</div>
				</div>
				<div className='col-md-12 d-flex setupaccount-footer'>
					<button disabled={state.demoForm.submitDisable} className='yr-cancelbtn' onClick={closeModal}>
						<span>Cancel</span>
					</button>
					<button
						disabled={state.demoForm.submitDisable}
						onClick={submitDemoForm}
						className='main_btn linear-gradient'>
						{state.demoForm.submitDisable ?
							<div className="spinner-border ml-auto" role="status" aria-hidden="true"></div> : 'Continue'
						}
					</button>
				</div>
			</div>
		);
	}

	return (
		<>
			<ToastContainer />
			<Header />
			<div className={`main_theme ${domain && 'white-lable'}`}>
				<section className="get-started py-5">
					<div className="container">
						<div className='row'>
							{/* <div className="col-lg-3 col-md-3 px-0  get-starteddiv"> */}
							<div className="col-lg-3 px-0">
								<h2 className='text-dark fs-4 fw-bold'>Get Started</h2>
								<p>Welcome to our playground! Use our context builder to let us know more information about our company or website.</p>
								<p>With the provided information, we'll build training material to plug into our AI model and allow for a simulated human conversation to take place.</p>
								<p>This conversation can be plugged in directly on to your website, Google Business Listing, Facebook Messenger accunt , and SMS text flows.</p>
							</div>
							{/* <div className='col-lg-9 col-md-9'> */}
							<div className='col-lg-9 '>
								{
									state.app.contextData &&
									<ul className="nav nav-pills mb-4" id="pills-tab" role="tablist">
										{/* <li className="nav-item" role="presentation">
											<button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Edit context</button>
										</li>
										<li className="nav-item" role="presentation">
											<button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Edit logos/color</button>
										</li> */}
										<li class="nav-item" role="presentation">
											<button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Edit context</button>
										</li>
										<li class="nav-item" role="presentation">
											<button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Edit logos/color</button>
										</li>
									</ul>
								}
								<div className="tab-content border p-3 rounded-3" id="pills-tabContent">
									{state.app.loading &&
										<div className='d-flex justify-content-center'>
											<div className="spinner-border text-success" role="status">
												<span className="sr-only">Loading...</span>
											</div>
										</div>
									}
									{state.app.contextData &&
										<>
											<TopActionButton />
											<EditContext
												defaultData={state.app.contextData}
												onAddQuestionFaq={onAddQuestionFaq}
											/>
											<EditLogo />

										</>
									}

								</div>
							</div>
						</div>
					</div>
				</section>
				{
					state.app.contextData &&
					<>
						<PersonalizedDemo />
						<PreviewChat isWhiteLable={domain ? true : false} />


						<section className="my-account-section py-5">
							<div className="container">
								<div className="text-center">
									<p className="fw-bold text-center text-dark fs-1 mb-5">Impressed? Let’s get you started!</p>

									<button
										className="main_btn linear-gradient px-5 py-3"
										onClick={openDemoForm}
									>Set Up My Account</button>
								</div>
							</div>
						</section>
						<ModalSignup
							show={showAskForModal}
							// modalFooter={modalFooter}
							modalBody={modalBody}
							title={modaltitle}
							closeModal={closeModal}
							modalLoader={modalLoader}
						/>
					</>
				}
			</div >

		</>
	);
}

export default App;
